'use client';

import type {As} from '@chakra-ui/react';
import type {ComponentWithAs, PropsOf} from '@chakra-ui/system';
import {forwardRef} from '@chakra-ui/system';
import {ChakraDiv} from '@linx-security/ui/utils/chakra-elements';

import type {WidgetContext} from './Container';
import {useStyles} from './context';

type Props = WidgetContext & PropsOf<typeof ChakraDiv>;

export const WidgetBody: ComponentWithAs<As, Props> = forwardRef(
  ({isInteractive: _isInteractive, isEmpty: _isEmpty, isLoading: _isLoading, hasError: _hasError, ...props}, ref) => {
    const {body: style} = useStyles();

    return (
      <ChakraDiv data-development={`dashboard-new8`} data-testid={`widget-body`} __css={style} {...props} ref={ref} />
    );
  },
);

export type {Props as WidgetBodyProps};
